const routeName = {
    SSO_Login: 'ssoLogin',

    LOGOUT: 'logout',
    HOME: 'home',
    // otp驗證
    OTP: 'otp',
    // 變更完成頁面
    FINISH: 'finish',
    // 變更資料確認頁
    CONFIRM_DATA: 'confirmData',

    // 官網申請電子通知單
    ENOTIFY: 'eNotify',
    ENOTIFY_LOGIN: 'eNotifyLogin',
    ENOTIFY_SELECT_EMAIL: 'eNotifySelectEmail',
    ENOTIFY_REGISTER: 'eNotifyRegister',
    ENOTIFY_OVER_YEAR_LIMIT: 'eNotifyOverYearLimit',
    ENOTIFY_OVER_YEAR_OTP: 'eNotifyOverYearOtp',

    CONTACT_INFO: 'contactInfo',
    // A3
    A3_SELECT_POLICY: 'selectPolicy3',
    A3_SET_ACCONT: 'setAccount3',
    A3_CONFIRM: 'confirm3',
    A3_OTP: 'otp3',

    // A4
    A4_SET_ACCONT: 'setAccount4',
    A4_CONFIRM: 'confirm4',
    A4_OTP: 'otp4',

    // A5 約定帳戶
    A5_SET_ACCONT: 'setAccount5',
    A5_CONFIRM: 'confirm5',
    A5_OTP: 'otp5',

    // A6 約定帳戶
    A6_SELECT_POLICY: 'selectPolicy6',
    A6_SET_ACCONT: 'setAccount6',
    A6_CONFIRM: 'confirm6',
    A6_OTP: 'otp6',

    // 簡訊寄發通知 (open pdf)
    PDF_TERMS: 'pfdTerms',
    PDF_LOGIN: 'pdfLofin',

    // VIP生日禮
    VIP_LOGIN: 'vipLogin',
    VIP_INFO: 'vipInfo',

    // 沒有權限
    NO_AUTH: 'noAuth',
    // 找不到頁面
    NOTFOUND: 'notFound',
    FORBIDDEN: 'forbidden',
    // 公告
    ANNOUNCEMENT: 'announcement',
    ERRORMESSAGE: 'errorMessage',

    SSOInputA1: 'SSOInputA1',
    SSOInputA3: 'SSOInputA3',
    SSOInputA4: 'SSOInputA4',
    SSOInputA5: 'SSOInputA5',
    SSOInputA6: 'SSOInputA6',
    SSOInputCamFrom3: 'SSOInputCamFrom3',
    SSOInputCamFrom4: 'SSOInputCamFrom4',
    SSOInputCamFrom5: 'SSOInputCamFrom5',
    SSOInputCamFrom6: 'SSOInputCamFrom6',

    LETTER_SSO_LOGIN: 'letterSsoLogin',
    LETTER_LOGIN: 'letterLogin',
    REDIRECT_ACCOUNT: 'redirectAccount',

    // TWID
    TWID_INIT: 'twidInit',
    TWID_MOBILE: 'twidMobile',
    TWID_RESULT: 'twidResult',
    TWID_FAILURE: 'twidFailure',

    // PAYACC
    PAYACC_POLICY: 'payAcc-policy-list',
    PAYACC_SELECT_POLICY: 'payAcc-set-account',
    PAYACC_CONFIRM: 'payAcc-confirm',
    PAYACC_FINISH: 'payAcc-finish',

};
export default Object.freeze(routeName);
